import TriangleRightIcon from './triangle-right-icon';

export default TriangleRightIcon;
